// docs: https://github.com/altostra/type-validations#readme
import { maybe, arrayOf, objectOf, recordOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

import type { EmailLink, LinkAliasMarkupDataResponse, ReplacedLidHrefData } from "../engagementLinkAliases";

export const isEmailLink = objectOf<EmailLink>({
  name: maybe(string),
  active: boolean,
  url: string,
  original_name: maybe(string),
  link_templates: maybe(recordOf({ key: string, value: recordOf({ key: string, value: string }) })),
  is_tracked: boolean,
  lid: maybe(string),
  nested: maybe(boolean),
  is_draft: maybe(boolean),
});

export const isReplacedLidHrefData = objectOf<ReplacedLidHrefData>({
  old: string,
  new: string,
});

export const isLinkAliasMarkupDataResponse = objectOf<LinkAliasMarkupDataResponse>({
  results: objectOf({
    link_includer_sequence_offset: number,
    content_block_inclusion_sequence_offset: number,
    draft_content_block_mappings: recordOf({ key: string, value: string }),
    has_legacy_cb_links: boolean,
    html: maybe(string),
    dnd_json: maybe(string),
    links: arrayOf(isEmailLink),
    tracked_link_count: number,
    warnings: objectOf({
      upsert_failed_hrefs: arrayOf(string),
      replaced_lid_hrefs: arrayOf(isReplacedLidHrefData),
    }),
  }),
});
